module.exports = __webpack_public_path__ + "876fa55857614f9d76db01ef2f3b5bbb.MP3";